export default __webpack_public_path__ + "static/media/pdf_icon.c6bdadf0.svg";